import { render, staticRenderFns } from "./MusicMenu.vue?vue&type=template&id=2aab3b30&scoped=true&"
import script from "./MusicMenu.vue?vue&type=script&lang=js&"
export * from "./MusicMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aab3b30",
  null
  
)

export default component.exports